import React, { useEffect } from 'react'
import { pageTitleFromPath } from './utils'

const PageTracker = WrappedComponent => {
  const HOC = props => {
    useEffect(() => {
      try {
        // eslint-disable-next-line prefer-destructuring
        const pathname = props.location.pathname // this format does not confuse the react-hooks/exhaustive-deps lint rule
        document.title = pageTitleFromPath(pathname)

        analytics.page()

        // Occasionally we need to style elements that live outside of our component, like intercom, but only on certain pages.
        // So make a classname available on the top-level body element
        const bodyElement = document.querySelector('body')
        bodyElement.setAttribute('class', `body-${pathname.split('/')[1]}`)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
    }, [props.location.pathname])

    return <WrappedComponent {...props} />
  }

  return HOC
}

export default PageTracker
